import React from 'react'
import { Pane, TextInput, Label, Radio, Flex } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'

import OidcModel from './OidcModel'
import S from './OidcEditor.css'

/**
 * @function OidcEditor A component for enabling a user to edit an oidc client based on its model
 * @component 
 * @property {object} value The model to be edited
 * @property {object} isEditable default is true 
 */
export default function OidcEditor( props ) {

  const { isEditable = true, value : model } = props
  const onModelChange = useValueChange( OidcModel, props )

  if ( model == null ) {
    return (
      <Pane variant="padding">
        No OpenID Connect Clients
      </Pane>
    )
  }

  return (
    <Pane variant="editor|padding">
      <div className={S.grid}>
        <Label variant="input">Provider Name</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getName( model )}
          size={30}
          eventData="setName"
          hint="Google"
          disabled={!isEditable}
          autoFocus
          onChange={onModelChange}/>
        <Label variant="input">Provider Alias</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getAlias( model )}
          size={30}
          eventData="setAlias"
          hint="google"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Provider Description</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getDescription( model )}
          size={30}
          eventData="setDescription"
          hint="Google OIDC client"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Discovery URL</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getDiscoveryUrl( model )}
          size={30}
          eventData="setDiscoveryUrl"
          hint="id.com/.well-known/oidc"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Client ID</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getClientId( model )}
          size={30}
          eventData="setClientId"
          hint="identity server code/id"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Client Secret</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getClientSecret( model )}
          size={30}
          eventData="setClientSecret"
          hint="client secret"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Scope</Label>
        <TextInput
          variant="oidc"
          value={OidcModel.getScope( model )}
          eventData="setScope"
          hint="scope"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Allow User Creation</Label>
        <Flex variant="rowM">
          <Radio
            variant="oidc"
            eventData="setAllowUserCreation"
            value={OidcModel.getAllowUserCreation( model ) === true}
            label="Yes"
            onChange={( { data, value } ) => onModelChange( { data, value : true } )} />
          <Radio
            variant="oidc"
            eventData="setAllowUserCreation"
            value={OidcModel.getAllowUserCreation( model ) === false}
            label="No"
            onChange={( { data, value } ) => onModelChange( { data, value : false } )} />
        </Flex>
      </div>
    </Pane>
  )
}
